msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: nl\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-10-14 15:38\n"
"Last-Translator: \n"
"Language-Team: Dutch\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: nl\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Vergrendeld"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Berichten: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Laatst geplaatst: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Geautomatiseerd"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:639
#: src/components/status.jsx:480
#: src/pages/catchup.jsx:1471
msgid "Group"
msgstr "Groep"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Wederzijds"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1680
msgid "Requested"
msgstr "Aangevraagd"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1671
msgid "Following"
msgstr "Volgend"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1062
msgid "Follows you"
msgstr "Volgt jou"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# volger} other {# volgers}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Geverifieerd"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:780
msgid "Joined <0>{0}</0>"
msgstr "Lid geworden op <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Altijd"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Kan account niet laden."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Ga naar de accountpagina"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Volgers"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:759
msgid "following.stats"
msgstr ""

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:776
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Berichten"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1118
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1703
#: src/components/status.jsx:1720
#: src/components/status.jsx:1844
#: src/components/status.jsx:2442
#: src/components/status.jsx:2445
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1181
#: src/pages/trending.jsx:471
msgid "More"
msgstr "meer"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> heeft aangegeven dat ze een nieuw account hebben:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1276
msgid "Handle copied"
msgstr "Kenmerk gekopieerd"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1279
msgid "Unable to copy handle"
msgstr "Kan dit kenmerk niet kopiëren"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1285
msgid "Copy handle"
msgstr "Kopieer kenmerk"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Ga naar de oorspronkelijke profielpagina"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Bekijk profielfoto"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Bekijk profielkop"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "In Memoriam"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:750
msgid "This user has chosen to not make this information available."
msgstr "Deze gebruiker heeft ervoor gekozen om deze informatie niet beschikbaar te maken."

#: src/components/account-info.jsx:805
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} originele berichten, {1} antwoorden, {2} boosts"

#: src/components/account-info.jsx:821
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Laatste bericht van de afgelopen dag} other {Laatste 1 bericht van de afgelopen {2} dagen}}} other {{3, plural, one {Laatste {4} berichten van de afgelopen dag} other {Laatste {5} berichten van de afgelopen {6} dagen}}}}"

#: src/components/account-info.jsx:834
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Laatste bericht van de afgelopen jaren} other {Laatste {1} berichten van de afgelopen jaren}}"

#: src/components/account-info.jsx:858
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Origineel"

#: src/components/account-info.jsx:862
#: src/components/status.jsx:2233
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:904
#: src/pages/status.jsx:1506
msgid "Replies"
msgstr "Antwoorden"

#: src/components/account-info.jsx:866
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1110
msgid "Boosts"
msgstr "Boosts"

#: src/components/account-info.jsx:872
msgid "Post stats unavailable."
msgstr "Berichtstatistieken niet beschikbaar."

#: src/components/account-info.jsx:903
msgid "View post stats"
msgstr "Bekijk berichtstatistieken"

#: src/components/account-info.jsx:1066
msgid "Last post: <0>{0}</0>"
msgstr "Laatste bericht: <0>{0}</0>"

#: src/components/account-info.jsx:1080
msgid "Muted"
msgstr "Gedempt"

#: src/components/account-info.jsx:1085
msgid "Blocked"
msgstr "Geblokkeerd"

#: src/components/account-info.jsx:1094
msgid "Private note"
msgstr "Privénotitie"

#: src/components/account-info.jsx:1151
msgid "Mention <0>@{username}</0>"
msgstr "Noem <0>@{username}</0>"

#: src/components/account-info.jsx:1163
msgid "Translate bio"
msgstr "Vertaal bio"

#: src/components/account-info.jsx:1174
msgid "Edit private note"
msgstr "Bewerk privénotitie"

#: src/components/account-info.jsx:1174
msgid "Add private note"
msgstr "Voeg privénotitie toe"

#: src/components/account-info.jsx:1194
msgid "Notifications enabled for @{username}'s posts."
msgstr "Meldingen ingeschakeld voor berichten van @{username}."

#: src/components/account-info.jsx:1195
msgid "Notifications disabled for @{username}'s posts."
msgstr "Meldingen uitgeschakeld voor berichten van @{username}."

#: src/components/account-info.jsx:1207
msgid "Disable notifications"
msgstr "Meldingen uitschakelen"

#: src/components/account-info.jsx:1208
msgid "Enable notifications"
msgstr "Meldingen inschakelen"

#: src/components/account-info.jsx:1225
msgid "Boosts from @{username} enabled."
msgstr "Boosts van @{username} ingeschakeld."

#: src/components/account-info.jsx:1226
msgid "Boosts from @{username} disabled."
msgstr "Boosts van @{username} uitgeschakeld."

#: src/components/account-info.jsx:1237
msgid "Disable boosts"
msgstr "Boosts uitschakelen"

#: src/components/account-info.jsx:1237
msgid "Enable boosts"
msgstr "Boosts inschakelen"

#: src/components/account-info.jsx:1253
#: src/components/account-info.jsx:1263
#: src/components/account-info.jsx:1864
msgid "Add/Remove from Lists"
msgstr "Toevoegen/Verwijderen uit lijsten"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1143
msgid "Link copied"
msgstr "Link gekopieerd"

#: src/components/account-info.jsx:1305
#: src/components/status.jsx:1146
msgid "Unable to copy link"
msgstr "Kan deze link niet kopiëren"

#: src/components/account-info.jsx:1311
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1152
#: src/components/status.jsx:3219
msgid "Copy"
msgstr "Kopiëer"

#: src/components/account-info.jsx:1326
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1168
msgid "Sharing doesn't seem to work."
msgstr "Delen lijkt niet te werken."

#: src/components/account-info.jsx:1332
#: src/components/status.jsx:1174
msgid "Share…"
msgstr "Delen…"

#: src/components/account-info.jsx:1352
msgid "Unmuted @{username}"
msgstr "Dempen van @{username} opgeheven"

#: src/components/account-info.jsx:1364
msgid "Unmute <0>@{username}</0>"
msgstr "Dempen van <0>@{username}</0> opheffen"

#: src/components/account-info.jsx:1380
msgid "Mute <0>@{username}</0>…"
msgstr "Demp <0>@{username}</0>…"

#: src/components/account-info.jsx:1412
msgid "Muted @{username} for {0}"
msgstr "@{username} gedempt voor {0}"

#: src/components/account-info.jsx:1424
msgid "Unable to mute @{username}"
msgstr "Kan @{username} niet dempen"

#: src/components/account-info.jsx:1445
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Verwijder <0>@{username}</0> van volgers?"

#: src/components/account-info.jsx:1465
msgid "@{username} removed from followers"
msgstr "@{username} verwijderd uit volgers"

#: src/components/account-info.jsx:1477
msgid "Remove follower…"
msgstr "Verwijder volger…"

#: src/components/account-info.jsx:1488
msgid "Block <0>@{username}</0>?"
msgstr "Blokkeer <0>@{username}</0>?"

#: src/components/account-info.jsx:1512
msgid "Unblocked @{username}"
msgstr "Blokkeren van @{username} opgeheven"

#: src/components/account-info.jsx:1520
msgid "Blocked @{username}"
msgstr "@{username} geblokkeerd"

#: src/components/account-info.jsx:1528
msgid "Unable to unblock @{username}"
msgstr "Kan @{username} niet ontblokkeren"

#: src/components/account-info.jsx:1530
msgid "Unable to block @{username}"
msgstr "Kan @{username} niet blokkeren"

#: src/components/account-info.jsx:1540
msgid "Unblock <0>@{username}</0>"
msgstr "Blokkeren van <0>@{username}</0> opheffen"

#: src/components/account-info.jsx:1549
msgid "Block <0>@{username}</0>…"
msgstr "Blokkeer <0>@{username}</0>…"

#: src/components/account-info.jsx:1566
msgid "Report <0>@{username}</0>…"
msgstr "Rapporteer <0>@{username}</0>…"

#: src/components/account-info.jsx:1586
#: src/components/account-info.jsx:2097
msgid "Edit profile"
msgstr "Bewerk profiel"

#: src/components/account-info.jsx:1622
msgid "Withdraw follow request?"
msgstr "Volgverzoek annuleren?"

#: src/components/account-info.jsx:1623
msgid "Unfollow @{0}?"
msgstr "Ontvolg @{0}?"

#: src/components/account-info.jsx:1674
msgid "Unfollow…"
msgstr "Ontvolg…"

#: src/components/account-info.jsx:1683
msgid "Withdraw…"
msgstr "Neem terug…"

#: src/components/account-info.jsx:1690
#: src/components/account-info.jsx:1694
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Volg"

#: src/components/account-info.jsx:1805
#: src/components/account-info.jsx:1859
#: src/components/account-info.jsx:1992
#: src/components/account-info.jsx:2092
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2944
#: src/components/status.jsx:3183
#: src/components/status.jsx:3681
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:76
#: src/pages/status.jsx:1268
msgid "Close"
msgstr "Sluit"

#: src/components/account-info.jsx:1810
msgid "Translated Bio"
msgstr "Vertaalde bio"

#: src/components/account-info.jsx:1904
msgid "Unable to remove from list."
msgstr "Kan niet uit lijst verwijderen."

#: src/components/account-info.jsx:1905
msgid "Unable to add to list."
msgstr "Kan niet aan lijst toevoegen."

#: src/components/account-info.jsx:1924
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Kan lijsten niet laden."

#: src/components/account-info.jsx:1928
msgid "No lists."
msgstr "Geen lijsten."

#: src/components/account-info.jsx:1939
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nieuwe lijst"

#: src/components/account-info.jsx:1997
msgid "Private note about <0>@{0}</0>"
msgstr "Privénotitie over <0>@{0}</0>"

#: src/components/account-info.jsx:2027
msgid "Unable to update private note."
msgstr "Kan privénotitie niet bijwerken."

#: src/components/account-info.jsx:2050
#: src/components/account-info.jsx:2220
msgid "Cancel"
msgstr "Annuleren"

#: src/components/account-info.jsx:2055
msgid "Save & close"
msgstr "Opslaan & sluiten"

#: src/components/account-info.jsx:2148
msgid "Unable to update profile."
msgstr "Kan profiel niet bijwerken."

#: src/components/account-info.jsx:2155
#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Naam"

#: src/components/account-info.jsx:2168
msgid "Bio"
msgstr "Bio"

#: src/components/account-info.jsx:2181
msgid "Extra fields"
msgstr "Extra velden"

#: src/components/account-info.jsx:2187
msgid "Label"
msgstr "Omschrijving"

#: src/components/account-info.jsx:2190
msgid "Content"
msgstr "Inhoud"

#: src/components/account-info.jsx:2223
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Opslaan"

#: src/components/account-info.jsx:2276
msgid "username"
msgstr "gebruikersnaam"

#: src/components/account-info.jsx:2280
msgid "server domain name"
msgstr "server domeinnaam"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Cloak-modus uitgeschakeld"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Cloak-modus ingeschakeld"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Startpagina"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Opstellen"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Je hebt niet-opgeslagen wijzigingen. Wil je dit bericht weggooien?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr ""

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Je kunt slechts 1 bestand bijvoegen.} other {Je kunt slechts # bestanden bijvoegen.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Uitklappen"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Minimaliseren"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Het lijkt erop dat je het bovenste venster hebt gesloten."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr ""

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Je hebt al een opstelveld open in het bovenliggende venster. Als je in dit venster wilt opstellen, worden de wijzigingen die je in het bovenliggende venster hebt aangebracht ongedaan gemaakt. Doorgaan?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Inklappen"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Antwoord op @{0}'s bericht (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "Antwoord op @{0}'s bericht"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Bronbericht bewerken"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Peiling moet minstens 2 opties hebben"

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Sommige peilingkeuzes zijn leeg"

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr ""

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Bijlage #{i} is mislukt"

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2029
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Inhoudswaarschuwing"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Inhoudswaarschuwing of gevoelige media"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:304
msgid "Public"
msgstr "Openbaar"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Lokaal"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:307
msgid "Unlisted"
msgstr "Niet openbaar"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:310
msgid "Followers only"
msgstr "Alleen volgers"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1907
msgid "Private mention"
msgstr "Privévermelding"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Plaats je antwoord"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Bewerk je bericht"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Wat ben je aan het doen?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Markeer media als gevoelig"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Voeg peiling toe"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Lokale emoji toevoegen"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:895
#: src/components/status.jsx:1683
#: src/components/status.jsx:1684
#: src/components/status.jsx:2338
msgid "Reply"
msgstr "Beantwoord"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Werk bij"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Plaats"

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "Download GIF…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "Downloaden GIF mislukt"

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "meer…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Geüpload"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Afbeeldingsbeschrijving"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Videobeschrijving"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Audiobeschrijving"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Bestandsgrootte is te groot. Uploaden kan problemen opleveren. Probeer de bestandsgrootte van {0} naar {1} of lager te verminderen."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimensies is te groot. Uploaden kan problemen opleveren. Probeer de dimensie van {0}x{1}px naar {2}x{3}px te verminderen."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Opnamesnelheid is te hoog. Uploaden kan problemen opleveren."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Verwijder"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Error"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Bewerk afbeeldingsbeschrijving"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Bewerk videobeschrijving"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Bewerk audiobeschrijving"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Omschrijving genereren. Even geduld…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Genereren van beschrijving mislukt: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Genereren van beschrijving mislukt"

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Genereer beschrijving…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Genereren van beschrijving mislukt: {0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>– experimenteel</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Gereed"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "Keuze {0}"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Meerdere keuzes"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Tijdsduur"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Verwijder peiling"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Zoek accounts"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Toevoegen"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Fout bij het laden van accounts"

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Aangepaste emoji"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Zoek emoji"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Fout bij het laden van aangepaste emojis"

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Recent gebruikt"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Overige"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} meer…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "GIF's zoeken"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "Mede mogelijk gemaakt door Giphy"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Typ om GIF's te zoeken"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Vorige"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Volgende"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Fout bij laden van GIF's"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:691
msgid "Unsent drafts"
msgstr "Niet-verzonden concepten"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Het lijkt erop dat je niet-verzonden concepten hebt. Laten we verder gaan waar je gebleven bent."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Verwijder dit concept?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Fout bij verwijderen concept! Probeer het opnieuw."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1318
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Verwijder…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Fout bij ophalen van de antwoordstatus!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Verwijder alle concepten?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Fout bij het verwijderen van concepten! Probeer het opnieuw."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Verwijder alles…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Geen concepten gevonden."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Peiling"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Media"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Openen in een nieuw venster"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Accepteren"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Weigeren"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Geaccepteerd"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Geweigerd"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Niets om te tonen"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Accounts"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1301
msgid "Show more…"
msgstr "Toon meer…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:459
msgid "The end."
msgstr "Het einde."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Sneltoetsen"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Sneltoetsen help"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Volgend bericht"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Vorig bericht"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Sla carrousel over naar volgend bericht"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Shift</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Sla carrousel over naar vorig bericht"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Shift</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Laad nieuwe berichten"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Open berichtdetails"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enter</0> of <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr ""

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Sluit bericht of dialoogvenster"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc</0> of <1>Backspace</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Focus kolom in multi-kolommodus"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> tot <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Stel nieuw bericht op"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Stel nieuw bericht op (nieuw venster)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Shift</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Verstuur bericht"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Ctrl</0> + <1>Enter</1> of <2>⌘</2> + <3>Enter</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Zoeken"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Beantwoord (nieuw venster)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Shift</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Like (favoriet)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> of <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:903
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
#: src/components/status.jsx:2397
msgid "Boost"
msgstr "Boost"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Shift</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:988
#: src/components/status.jsx:2421
#: src/components/status.jsx:2422
msgid "Bookmark"
msgstr "Bladwijzer"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Schakel Cloak-modus"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Shift</0> + <1>Alt</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Bewerk lijst"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Kan lijst niet bewerken."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Kan lijst niet aanmaken."

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Toon antwoorden aan ledenlijst"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Toon antwoorden aan mensen die ik volg"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Geen antwoorden tonen"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr ""

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Aanmaken"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Deze lijst verwijderen?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Kan lijst niet verwijderen."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Mediabeschrijving"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1032
#: src/components/status.jsx:1059
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Vertaal"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1046
#: src/components/status.jsx:1073
msgid "Speak"
msgstr "Spreek uit"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Open originele media in nieuw venster"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Open originele media"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr ""

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Fout bij het beschrijven van afbeelding"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Beschrijf afbeelding…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Bekijk bericht"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Gevoelige media"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Gefilterd: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3511
#: src/components/status.jsx:3607
#: src/components/status.jsx:3685
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Gefilterd"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Bericht geplaatst. Bekijk het eens."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Antwoord geplaatst. Bekijk het eens."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Bericht bijgewerkt. Bekijk het eens."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menu"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Pagina herladen om bij te werken?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nieuwe update beschikbaar…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr ""

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Inhalen"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1102
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Vermeldingen"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Meldingen"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nieuw"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profiel"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Lijsten"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Alle lijsten"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Bladwijzers"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1106
msgid "Likes"
msgstr "Likes"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Gevolgde Hashtags"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filters"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Gedempte gebruikers"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Gedempte gebruikers…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Geblokkeerde gebruikers"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Geblokkeerde gebruikers…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Accounts…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:189
#: src/pages/status.jsx:804
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Inloggen"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Populair"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Gefedereerd"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Snelkoppelingen / Kolommen…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Instellingen…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Melding"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Deze melding komt van je andere account."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Toon alle meldingen"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr ""

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "{account} heeft een bericht gepubliceerd."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} heeft je antwoord gedeeld.} other {{account} heeft je bericht gedeeld.}}} other {{account} heeft {postsCount} van je berichten gedeeld.}}} other {{postType, select, reply {<0><1>{0}</1> mensen</0> hebben je antwoord gedeeld.} other {<2><3>{1}</3> mensen</2> hebben je berichten gedeeld.}}}}"

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr ""

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} heeft verzocht je te volgen."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} heeft je antwoord geliket.} other {{account} heeft je bericht geliket.}}} other {{account} heeft {postsCount} van je berichten geliket.}}} other {{postType, select, reply {<0><1>{0}</1> mensen</0> hebben je antwoord geliket.} other {<2><3>{1}</3> mensen</2> hebben je bericht geliket.}}}}"

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Een peiling die je hebt aangemaakt of waarin je hebt gestemd is geëindigd."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr "Een peiling die je hebt aangemaakt is geëindigd."

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr "Een peiling waarin je hebt gestemd is geëindigd."

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr ""

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} heeft je antwoord geboost & geliket.} other {{account} heeft je bericht geboost & geliket.}}} other {{account} heeft {postsCount} van je berichten geboost & geliket.}}} other {{postType, select, reply {<0><1>{0}</1> mensen</0> hebben je antwoord geboost & geliket.} other {<2><3>{1}</3> mensen</2> hebben je bericht geboost & geliket.}}}}"

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr "{account} heeft zich aangemeld."

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr ""

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr "Verbindingen verbroken met <0>{name}</0>."

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Moderatie-waarschuwing"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Een beheerder van <0>{from}</0> heeft <1>{targetName}</1> geschorst, wat betekent dat u geen updates meer van hen kunt ontvangen of met hen kunt communiceren."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Een admin van <0>{from}</0> heeft <1>{targetName}</1> geblokkeerd. Getroffen volgers: {followersCount}, volgt: {followingCount}."

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Je hebt <0>{targetName}</0> geblokkeerd. Verwijderde volgers: {followersCount}, volgt: {followingCount}."

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Jouw account heeft een moderatie-waarschuwing ontvangen."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr ""

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr ""

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr ""

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr ""

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Je account is beperkt."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Je account is geschorst."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Onbekend meldingstype: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1002
#: src/components/status.jsx:1012
msgid "Boosted/Liked by…"
msgstr "Geboost/Geliket door…"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Geliket door…"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Geboost door…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Gevolgd door…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Leer meer <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:211
msgid "Read more →"
msgstr "Lees meer →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Gestemd"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# stem} other {# stemmen}}"

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Verberg uitslagen"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Stem"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1170
#: src/pages/status.jsx:1193
msgid "Refresh"
msgstr "Ververs"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Toon uitslagen"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> stem} other {<1>{1}</1> stemmen}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> stemmer} other {<1>{1}</1> stemmers}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Eindigde <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Geëindigd"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr "Eindigt <0/>"

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Eindigt"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0} s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0} m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0} u"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Spam"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr ""

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Illegaal"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr ""

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr ""

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr ""

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Overtreding"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Overig"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr ""

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Rapporteer bericht"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Rapporteer @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Openstaande review"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr ""

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr ""

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr ""

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr ""

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Wat is het probleem met dit bericht?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Wat is het probleem met dit profiel?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Extra informatie"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Doorsturen naar <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Verzend rapport"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "{username} gedempt"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Kan {username} niet dempen"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Verzend rapport <0>+ Demp profiel</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "{username} geblokkeerd"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Kan {username} niet blokkeren"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Verzend rapport <0>+ Blokkeer profiel</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ accounts, hashtags & berichten</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr ""

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr ""

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Zoek <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Accounts met <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Startpagina / Volgend"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Openbaar (Lokaal / Gefederaliseerd)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Account"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Hashtag"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Lijst-id"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Alleen lokaal"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Instantie"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Optioneel, bijv. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Zoekterm"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Optioneel, behalve voor de multi-kolommodus"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "bijv. PixelArt (Max 5, spatie gescheiden)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Alleen media"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Snelkoppelingen"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "bèta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr ""

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Zwevende knop"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Tab-/Menubalk"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Multi-kolom"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Niet beschikbaar in huidige weergavemodus"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Verplaats omhoog"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Verplaats omlaag"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1280
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Bewerk"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr ""

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr ""

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr ""

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Geen idee wat je kunt toevoegen?<0/>Probeer eerst <1>Startpagina/Volgend of Meldingen</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Max. {SHORTCUTS_LIMIT} kolommen"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Max. {SHORTCUTS_LIMIT} snelkoppelingen"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importeer/Exporteer"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Voeg kolom toe…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Voeg snelkoppeling toe…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Specifieke lijst is optioneel. Voor de multi-kolommodus is een lijst vereist, anders wordt de kolom niet getoond."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Voor de multi-kolommodus is een zoekterm vereist, anders wordt de kolom niet getoond."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr ""

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Bewerk snelkoppeling"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Voeg snelkoppeling toe"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Tijdlijn"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Lijst"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importeer/Exporteer <0>Snelkoppelingen</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importeer"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Plak snelkoppelingen hier"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Opgeslagen snelkoppelingen downloaden van instance server…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Kan snelkoppelingen niet downloaden"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Download snelkoppelingen van de instance server"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr ""

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr ""

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr ""

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr ""

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr ""

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Geen nieuwe snelkoppelingen om te importeren"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Snelkoppelingen geïmporteerd. De maximum van {SHORTCUTS_LIMIT} is overschreden, de rest wordt niet geïmporteerd."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Snelkoppelingen geïmporteerd"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importeren & toevoegen…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Huidige snelkoppelingen overschrijven?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Snelkoppelingen importeren?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "or overschrijven…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importeer…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Exporteer"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Snelkoppelingen gekopieerd"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Kan snelkoppelingen niet kopiëren"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Snelkoppelingsinstellingen gekopieerd"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Kan snelkoppelingsinstellingen niet kopiëren"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Delen"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Snelkoppelingen opslaan naar instance server…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Snelkoppeling opgeslagen"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Kan snelkoppelingen niet opslaan"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Synchroniseer naar de instance server"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# teken} other {# tekens}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Ruwe Snelkoppelingen JSON"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importeer/exporteer instellingen van/naar instance server (zeer experimenteel)"

#: src/components/status.jsx:504
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>geboost</1>"

#: src/components/status.jsx:603
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Sorry, je momentieel ingelogde instantie kan niet communiceren met dit bericht van een andere instantie."

#: src/components/status.jsx:756
msgid "Unliked @{0}'s post"
msgstr "@{0}'s bericht niet langer geliket"

#: src/components/status.jsx:757
msgid "Liked @{0}'s post"
msgstr "@{0}'s bericht geliket"

#: src/components/status.jsx:796
msgid "Unbookmarked @{0}'s post"
msgstr ""

#: src/components/status.jsx:797
msgid "Bookmarked @{0}'s post"
msgstr ""

#: src/components/status.jsx:903
#: src/components/status.jsx:965
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
msgid "Unboost"
msgstr "Niet langer boosten"

#: src/components/status.jsx:919
#: src/components/status.jsx:2379
msgid "Quote"
msgstr ""

#: src/components/status.jsx:927
#: src/components/status.jsx:2388
msgid "Some media have no descriptions."
msgstr ""

#: src/components/status.jsx:934
msgid "Old post (<0>{0}</0>)"
msgstr ""

#: src/components/status.jsx:953
#: src/components/status.jsx:1408
msgid "Unboosted @{0}'s post"
msgstr "@{0}'s bericht niet langer geboost"

#: src/components/status.jsx:954
#: src/components/status.jsx:1409
msgid "Boosted @{0}'s post"
msgstr "@{0}'s bericht geboost"

#: src/components/status.jsx:966
msgid "Boost…"
msgstr "Boost…"

#: src/components/status.jsx:978
#: src/components/status.jsx:1693
#: src/components/status.jsx:2409
msgid "Unlike"
msgstr "Niet langer liken"

#: src/components/status.jsx:979
#: src/components/status.jsx:1693
#: src/components/status.jsx:1694
#: src/components/status.jsx:2409
#: src/components/status.jsx:2410
msgid "Like"
msgstr "Like"

#: src/components/status.jsx:988
#: src/components/status.jsx:2421
msgid "Unbookmark"
msgstr ""

#: src/components/status.jsx:1096
msgid "View post by <0>@{0}</0>"
msgstr ""

#: src/components/status.jsx:1117
msgid "Show Edit History"
msgstr ""

#: src/components/status.jsx:1120
msgid "Edited: {editedDateText}"
msgstr ""

#: src/components/status.jsx:1187
#: src/components/status.jsx:3188
msgid "Embed post"
msgstr ""

#: src/components/status.jsx:1201
msgid "Conversation unmuted"
msgstr ""

#: src/components/status.jsx:1201
msgid "Conversation muted"
msgstr ""

#: src/components/status.jsx:1207
msgid "Unable to unmute conversation"
msgstr ""

#: src/components/status.jsx:1208
msgid "Unable to mute conversation"
msgstr ""

#: src/components/status.jsx:1217
msgid "Unmute conversation"
msgstr ""

#: src/components/status.jsx:1224
msgid "Mute conversation"
msgstr ""

#: src/components/status.jsx:1240
msgid "Post unpinned from profile"
msgstr ""

#: src/components/status.jsx:1241
msgid "Post pinned to profile"
msgstr ""

#: src/components/status.jsx:1246
msgid "Unable to unpin post"
msgstr ""

#: src/components/status.jsx:1246
msgid "Unable to pin post"
msgstr ""

#: src/components/status.jsx:1255
msgid "Unpin from profile"
msgstr ""

#: src/components/status.jsx:1262
msgid "Pin to profile"
msgstr ""

#: src/components/status.jsx:1291
msgid "Delete this post?"
msgstr ""

#: src/components/status.jsx:1307
msgid "Post deleted"
msgstr ""

#: src/components/status.jsx:1310
msgid "Unable to delete post"
msgstr "Kan bericht niet verwijderen"

#: src/components/status.jsx:1338
msgid "Report post…"
msgstr ""

#: src/components/status.jsx:1694
#: src/components/status.jsx:1730
#: src/components/status.jsx:2410
msgid "Liked"
msgstr "Geliket"

#: src/components/status.jsx:1727
#: src/components/status.jsx:2397
msgid "Boosted"
msgstr "Geboost"

#: src/components/status.jsx:1737
#: src/components/status.jsx:2422
msgid "Bookmarked"
msgstr "Bladwijzer opgeslagen"

#: src/components/status.jsx:1741
msgid "Pinned"
msgstr "Vastgezet"

#: src/components/status.jsx:1786
#: src/components/status.jsx:2241
msgid "Deleted"
msgstr "Verwijderd"

#: src/components/status.jsx:1827
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# antwoord} other {# antwoorden}}"

#: src/components/status.jsx:1916
msgid "Thread{0}"
msgstr "Draad{0}"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
#: src/components/status.jsx:2139
msgid "Show less"
msgstr "Toon minder"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
msgid "Show content"
msgstr "Toon inhoud"

#: src/components/status.jsx:2139
msgid "Show media"
msgstr "Toon media"

#: src/components/status.jsx:2262
msgid "Edited"
msgstr "Bewerkt"

#: src/components/status.jsx:2339
msgid "Comments"
msgstr "Antwoorden"

#. More from [Author]
#: src/components/status.jsx:2648
msgid "More from <0/>"
msgstr ""

#: src/components/status.jsx:2949
msgid "Edit History"
msgstr "Bewerkingsgeschiedenis"

#: src/components/status.jsx:2953
msgid "Failed to load history"
msgstr "Kon geschiedenis niet laden"

#: src/components/status.jsx:2958
msgid "Loading…"
msgstr "Laden…"

#: src/components/status.jsx:3193
msgid "HTML Code"
msgstr "HTML code"

#: src/components/status.jsx:3210
msgid "HTML code copied"
msgstr "HTML code gekopieerd"

#: src/components/status.jsx:3213
msgid "Unable to copy HTML code"
msgstr "Kan HTML-code niet kopiëren"

#: src/components/status.jsx:3225
msgid "Media attachments:"
msgstr "Mediabijlagen:"

#: src/components/status.jsx:3247
msgid "Account Emojis:"
msgstr "Account emoji's:"

#: src/components/status.jsx:3278
#: src/components/status.jsx:3323
msgid "static URL"
msgstr "statische URL"

#: src/components/status.jsx:3292
msgid "Emojis:"
msgstr "Emoji's:"

#: src/components/status.jsx:3337
msgid "Notes:"
msgstr "Notities:"

#: src/components/status.jsx:3341
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Dit is statisch, zonder vormgeving en scriptloos. Je moet mogelijk je eigen vormgeving toepassen en bewerken waar nodig."

#: src/components/status.jsx:3347
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Peilingen zijn niet interactief, wordt een lijst met uitslagen."

#: src/components/status.jsx:3352
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Mediabijlagen kunnen afbeeldingen, video's, audiobestanden of andere bestandstypes zijn."

#: src/components/status.jsx:3358
msgid "Post could be edited or deleted later."
msgstr ""

#: src/components/status.jsx:3364
msgid "Preview"
msgstr ""

#: src/components/status.jsx:3373
msgid "Note: This preview is lightly styled."
msgstr "Let op: Deze voorvertoning is licht vormgegeven."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3615
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> geboost"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1130
msgid "New posts"
msgstr "Nieuwe berichten"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:957
#: src/pages/status.jsx:1330
msgid "Try again"
msgstr ""

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Boost} other {# Boosts}}"

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr ""

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr ""

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr ""

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr ""

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr ""

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr ""

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr ""

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr ""

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr ""

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Bron status bewerken"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Antwoorden op @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr ""

#: src/compose.jsx:70
msgid "Close window"
msgstr ""

#: src/compose.jsx:86
msgid "Login required."
msgstr ""

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Naar startpagina"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Berichten van account"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Antwoorden)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Boosts)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Media)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Wis filters"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Wis"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Berichten met antwoorden worden nu getoond"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Antwoorden"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Alle berichten zonder boosts"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Boosts"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Berichten met media worden nu getoond"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Alle berichten met tag #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Alle berichten uit {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Nog niets te zien hier."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "Kan berichten niet laden"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Kan accountgegevens niet ophalen"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Overschakelen naar instantie van account {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Overschakelen naar mijn instantie (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr ""

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr ""

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr ""

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Overschakelen naar dit account"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr ""

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr ""

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr ""

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr ""

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr ""

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr ""

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Let op: <0>Standaard</0> account zal altijd bij het het eerste laden worden gebruikt. Overgeschakelde accounts worden onthouden tijdens je sessie."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr ""

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Kan bladwijzers niet laden."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "het afgelopen uur"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "de afgelopen 2 uur"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "de afgelopen 3 uur"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "de afgelopen 4 uur"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "de afgelopen 5 uur"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "de afgelopen 6 uur"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "de afgelopen 7 uur"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "de afgelopen 8 uur"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "de afgelopen 9 uur"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "de afgelopen 10 uur"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "de afgelopen 11 uur"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "de afgelopen 12 uur"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "meer dan 12 uur geleden"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Gevolgde hashtags"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Groepen"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "{selectedFilterCategory, select, all {Alle berichten} original {Alle originele berichten} replies {Alle antwoorden} boosts {Alle boosts} followedTags {Alle gevolgde tags} groups {Alle groepen} filtered {Alle gefilterde berichten}}, {sortBy, select, createdAt {{sortOrder, select, asc {oudste} desc {nieuwste}}} reblogsCount {{sortOrder, select, asc {minste boosts} desc {meeste boosts}}} favouritesCount {{sortOrder, select, asc {minste likes} desc {meeste likes}}} repliesCount {{sortOrder, select, asc {minste antwoorden} desc {meeste antwoorden}}} density {{sortOrder, select, asc {minst dichte} desc {meest dichte}}}} first{groupBy, select, account {, gegroepeerd per schrijver} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Inhalen <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Hulp"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Wat is dit?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Inhalen is een aparte tijdlijn voor de accounts die je volgt, dat een weergave op hoog niveau in één oogopslag biedt met een eenvoudige, e-mailgeïnspireerde interface om moeiteloos door berichten te sorteren en filteren."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Voorbeeld van de Inhalen UI"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Laten we inhalen"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Laten we de posts van je de accounts die je volgt inhalen."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Toon me alle berichten van…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "tot het maximum"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Catch up"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Overlapt met je laatste catch-up"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Tot aan de laatste catch-up ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Let op: je instantie mag max. 800 berichten in de startpaginatijdlijn tonen, ongeacht het tijdsbereik. Kan minder of meer berichten zijn."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Eerder…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# bericht} other {# berichten}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Deze catch-up verwijderen?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Let op: Max. 3 worden opgeslagen. De rest wordt automatisch verwijderd."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Berichten ophalen…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Dit kan even duren."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Filters terug zetten"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Top links"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Gedeeld door {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Alles"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# auteur} other {# auteurs}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Sorteer"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Datum"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Dichtheid"

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Auteurs"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Geen"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Toon alle auteurs"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Je hoeft niet alles te lezen."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "Dat was het."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Terug naar boven"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Links gedeeld door volgenden, gesorteerd op hoe vaak het is gedeeld, geboost en geliket."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Sorteer: Dichtheid"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr ""

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Groep: Auteurs"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr ""

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Volgende auteur"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Vorige auteur"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Scroll naar boven"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Gefilterd: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr "Nog geen likes. Ga iets liken!"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Kan likes niet laden."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Startpagina en lijsten"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Openbare tijdlijnen"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Discussies"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profielen"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Nooit"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nieuw filter"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filter} other {# filters}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Kan filters niet laden."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Nog geen filters."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Voeg filter toe"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Bewerk filter"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Kan filter niet bewerken"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Kan filter niet aanmaken"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Titel"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Volledig woord"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Geen trefwoorden. Voeg er één toe."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Voeg trefwoord toe"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# trefwoord} other {# trefwoorden}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filter op…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Nog niet geïmplementeerd"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Status: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Wijzig vervaldatum"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Vervaldatum"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Gefilterd bericht zal worden…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "geminimaliseerd"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "verborgen"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Verwijder dit filter?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Kan filter niet verwijderen."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Vervallen"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Vervalt op <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Vervalt nooit"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# hashtag} other {# hashtags}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Kan gevolgde hashtags niet laden."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Nog geen hashtags gevolgd."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Niets te zien hier."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Kan berichten niet laden."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Alleen media) uit {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} uit {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Alleen media)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Nog niemand heeft iets met deze hashtag geplaatst."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Kan berichten met deze tag niet laden"

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr "Ontvolg #{hashtag}?"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "#{hashtag} ontvolgd"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "#{hashtag} gevolgd"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Volgend…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr ""

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr ""

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr ""

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr ""

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr ""

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Voeg hashtag toe"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Verwijder hashtag"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr ""

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr ""

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr ""

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Voeg aan Snelkoppelingen toe"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Voer een nieuwe instantie in, bijv. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Ongeldige instantie"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Ga naar een andere instantie…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Ga naar mijn instantie (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "Kan meldingen niet ophalen."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr ""

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Bekijk alles"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Bezig met verwerken…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Kan URL niet vinden"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Nog niks."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Beheer leden"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Verwijder <0>@{0}</0> van lijst?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Verwijder…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {# lijst} other {# lijsten}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Nog geen lijsten."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr ""

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr "instantiedomein"

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "bijv. “mastodon.social”"

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr "Inloggen mislukt. Probeer het opnieuw of probeer een andere instantie."

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Doorgaan met {selectedInstanceText}"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Doorgaan"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Nog geen account? Maak er een aan!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Privévermeldingen"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privé"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Niemand vermeld je :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Kan vermeldingen niet laden."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Die je niet volgt"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Die je niet volgen"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "Met een nieuw account"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "Die je ongevraagd privé noemen"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr ""

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Meldingsinstellingen"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Nieuwe meldingen"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Mededeling} other {Mededelingen}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1118
msgid "Follow requests"
msgstr "Volgverzoeken"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# volgverzoek} other {# volgverzoeken}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr ""

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Alleen vermeldingen"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Vandaag"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Je bent weer helemaal bij."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Gisteren"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "Kan meldingen niet laden"

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Meldingsinstellingen bijgewerkt"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr ""

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Filter"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Negeren"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr ""

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr ""

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr ""

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Sta toe"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr ""

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr ""

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Negeer"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Genegeerd"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Lokale tijdlijn ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Federale tijdlijn ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Lokale tijdlijn"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Federale tijdlijn"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Niemand heeft nog iets geplaatst."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Overschakelen naar Federatie"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Overschakelen naar Lokaal"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Zoek: {q} (Berichten)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Zoek: {q} (Accounts)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Zoek: {q} (Hashtags)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Zoeken: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Hashtags"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Bekijk meer"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Bekijk meer accounts"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Geen accounts gevonden."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Bekijk meer hashtags"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Geen hashtags gevonden."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Bekijk meer berichten"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Geen berichten gevonden."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr ""

#: src/pages/settings.jsx:81
msgid "Settings"
msgstr "Instellingen"

#: src/pages/settings.jsx:90
msgid "Appearance"
msgstr "Weergave"

#: src/pages/settings.jsx:166
msgid "Light"
msgstr "Licht"

#: src/pages/settings.jsx:177
msgid "Dark"
msgstr "Donker"

#: src/pages/settings.jsx:190
msgid "Auto"
msgstr "Automatisch"

#: src/pages/settings.jsx:200
msgid "Text size"
msgstr "Lettergrootte"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:205
#: src/pages/settings.jsx:230
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:244
msgid "Display language"
msgstr "Weergavetaal"

#: src/pages/settings.jsx:253
msgid "Volunteer translations"
msgstr "Vertalingen van vrijwilligers"

#: src/pages/settings.jsx:264
msgid "Posting"
msgstr "Plaatsen"

#: src/pages/settings.jsx:271
msgid "Default visibility"
msgstr "Standaard zichtbaarheid"

#: src/pages/settings.jsx:272
#: src/pages/settings.jsx:318
msgid "Synced"
msgstr "Gesynchroniseerd"

#: src/pages/settings.jsx:297
msgid "Failed to update posting privacy"
msgstr ""

#: src/pages/settings.jsx:320
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Gesynchroniseerd met de instellingen van je instance server. <0>Ga naar je instance ({instance}) voor meer instellingen.</0>"

#: src/pages/settings.jsx:335
msgid "Experiments"
msgstr "Experimenten"

#: src/pages/settings.jsx:348
msgid "Auto refresh timeline posts"
msgstr ""

#: src/pages/settings.jsx:360
msgid "Boosts carousel"
msgstr "Boosts carrousel"

#: src/pages/settings.jsx:376
msgid "Post translation"
msgstr "Berichtvertaling"

#: src/pages/settings.jsx:387
msgid "Translate to"
msgstr "Vertaal naar"

#: src/pages/settings.jsx:398
msgid "System language ({systemTargetLanguageText})"
msgstr "Systeemtaal ({systemTargetLanguageText})"

#: src/pages/settings.jsx:424
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr ""

#: src/pages/settings.jsx:478
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Let op: Deze functie maakt gebruik van externe vertaaldiensten, mede mogelijk gemaakt door <0>Lingva API</0> & <1>Lingva Translate</1>."

#: src/pages/settings.jsx:512
msgid "Auto inline translation"
msgstr ""

#: src/pages/settings.jsx:516
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr ""

#: src/pages/settings.jsx:536
msgid "GIF Picker for composer"
msgstr ""

#: src/pages/settings.jsx:540
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Let op: Deze functie maakt gebruik van een externe GIF zoekdienst, mede mogelijk gemaakt door <0>GIPHY</0>. Geschikt voor alle leeftijden, tracking parameters worden geschrapt, verwijzerinformatie wordt weggelaten uit verzoeken, maar zoekopdrachten en het IP-adres zullen hun servers nog steeds bereiken."

#: src/pages/settings.jsx:569
msgid "Image description generator"
msgstr ""

#: src/pages/settings.jsx:574
msgid "Only for new images while composing new posts."
msgstr ""

#: src/pages/settings.jsx:581
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Let op: Deze functie maakt gebruik van externe AI-service, gevoed door <0>img-alt-api</0>. Kan mogelijk niet goed werken. Alleen voor afbeeldingen in het Engels."

#: src/pages/settings.jsx:607
msgid "Server-side grouped notifications"
msgstr ""

#: src/pages/settings.jsx:611
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr ""

#: src/pages/settings.jsx:632
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "\"Cloud\" import/export voor snelkoppelingsinstellingen"

#: src/pages/settings.jsx:637
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Zeer experimenteel.<0/>Opgeslagen in je eigen profielnotities. (Privé) profielnotities worden voornamelijk gebruikt voor andere profielen en verborgen voor je eigen profiel."

#: src/pages/settings.jsx:648
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Let op: Deze functie maakt gebruik van de API van de instance server waar je momenteel bent ingelogd."

#: src/pages/settings.jsx:665
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr ""

#: src/pages/settings.jsx:674
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr ""

#: src/pages/settings.jsx:699
msgid "About"
msgstr "Over"

#: src/pages/settings.jsx:738
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr ""

#: src/pages/settings.jsx:767
msgid "Sponsor"
msgstr "Sponsor"

#: src/pages/settings.jsx:775
msgid "Donate"
msgstr "Doneer"

#: src/pages/settings.jsx:783
msgid "Privacy Policy"
msgstr "Privacybeleid"

#: src/pages/settings.jsx:790
msgid "<0>Site:</0> {0}"
msgstr "<0>Site:</0> {0}"

#: src/pages/settings.jsx:797
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versie:</0> <1/> {0}"

#: src/pages/settings.jsx:812
msgid "Version string copied"
msgstr "Versiestring gekopieerd"

#: src/pages/settings.jsx:815
msgid "Unable to copy version string"
msgstr ""

#: src/pages/settings.jsx:1015
#: src/pages/settings.jsx:1020
msgid "Failed to update subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1026
msgid "Failed to remove subscription. Please try again."
msgstr ""

#: src/pages/settings.jsx:1033
msgid "Push Notifications (beta)"
msgstr "Pushmeldingen (bèta)"

#: src/pages/settings.jsx:1055
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr ""

#: src/pages/settings.jsx:1064
msgid "Allow from <0>{0}</0>"
msgstr "Sta toe van <0>{0}</0>"

#: src/pages/settings.jsx:1073
msgid "anyone"
msgstr "iedereen"

#: src/pages/settings.jsx:1077
msgid "people I follow"
msgstr "mensen die ik volg"

#: src/pages/settings.jsx:1081
msgid "followers"
msgstr "volgers"

#: src/pages/settings.jsx:1114
msgid "Follows"
msgstr "Volgend"

#: src/pages/settings.jsx:1122
msgid "Polls"
msgstr "Peilingen"

#: src/pages/settings.jsx:1126
msgid "Post edits"
msgstr "Plaats bewerkingen"

#: src/pages/settings.jsx:1147
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr ""

#: src/pages/settings.jsx:1163
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "LET OP: Push meldingen werken alleen voor <0>één account</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:567
#: src/pages/status.jsx:1100
msgid "post.title"
msgstr ""

#: src/pages/status.jsx:791
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Je bent niet ingelogd. Interacties (antwoorden, boosten, etc) zijn niet mogelijk."

#: src/pages/status.jsx:811
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Dit bericht komt uit een andere instantie (<0>{instance}</0>). Interacties (antwoorden, boosten, etc.) zijn niet mogelijk."

#: src/pages/status.jsx:839
msgid "Error: {e}"
msgstr "Fout: {e}"

#: src/pages/status.jsx:846
msgid "Switch to my instance to enable interactions"
msgstr "Overschakelen naar mijn instantie om interacties in te schakelen"

#: src/pages/status.jsx:948
msgid "Unable to load replies."
msgstr "Kan antwoorden niet laden."

#: src/pages/status.jsx:1060
msgid "Back"
msgstr "Terug"

#: src/pages/status.jsx:1091
msgid "Go to main post"
msgstr "Ga naar het hoofdbericht"

#: src/pages/status.jsx:1114
msgid "{0} posts above ‒ Go to top"
msgstr "{0} berichten boven - Go naar boven"

#: src/pages/status.jsx:1157
#: src/pages/status.jsx:1220
msgid "Switch to Side Peek view"
msgstr ""

#: src/pages/status.jsx:1221
msgid "Switch to Full view"
msgstr ""

#: src/pages/status.jsx:1239
msgid "Show all sensitive content"
msgstr "Toon alle gevoelige inhoud"

#: src/pages/status.jsx:1244
msgid "Experimental"
msgstr "Experimenteel"

#: src/pages/status.jsx:1253
msgid "Unable to switch"
msgstr "Kan niet overschakelen"

#: src/pages/status.jsx:1260
msgid "Switch to post's instance ({0})"
msgstr "Overschakelen naar instantie van bericht ({0})"

#: src/pages/status.jsx:1263
msgid "Switch to post's instance"
msgstr "Overschakelen naar instantie van bericht"

#: src/pages/status.jsx:1321
msgid "Unable to load post"
msgstr "Kan bericht niet laden"

#: src/pages/status.jsx:1438
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# antwoord} other {<0>{1}</0> antwoorden}}"

#: src/pages/status.jsx:1456
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# opmerking} other {<0>{0}</0> opmerkingen}}"

#: src/pages/status.jsx:1478
msgid "View post with its replies"
msgstr "Bekijk bericht met antwoorden"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "Populair ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Populair nieuws"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr ""

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Terug naar alle populaire berichten"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Alle berichten over <0>{0}</0>"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Populaire berichten"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Geen populaire berichten."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr ""

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Aanmelden met Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Inschrijven"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr ""

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr ""

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Screenshot van Boosts carrousel"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Boosts carrousel"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Visueel scheiden van originele berichten en opnieuw gedeelde berichten (gebooste berichten)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr ""

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Moeiteloos gesprekken volgen. Semi-inklapbare antwoorden."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr ""

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Gegroepeerde meldingen"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr ""

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Schermafbeelding van multi-kolommodus"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Enkel- of multi-kolom"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Standaard enkelvoudige kolom voor zen-moduszoekers. Instelbare multi-kolommodus voor power users."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr ""

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr ""

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr ""

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Het lijkt erop dat je browser popups blokkeert."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr ""

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr ""

